<ui-card *ngIf="someApplicantInterviewersSubmitted">
    <app-segment-header
        title="Feedback"
        subtitle="applicant-tracker.applicant-interview-feedback-results.subtitle"
    ></app-segment-header>
    <hr />
    <ng-container *ngIf="allApplicantInterviewersSubmitted || hasRecruiterAccess; else emptyState">
        <div
            *ngFor="
                let interviewQuestionsWithFeedbackResult of interviewQuestionsWithFeedbackResults;
                let index = index
            "
            class="padding-3 feedback-view margin-bottom-3"
        >
            <!-- Yes / No Question -->
            <ng-container
                *ngIf="
                    interviewQuestionsWithFeedbackResult.interviewQuestionType.name ===
                    applicantInterviewQuestionTypes.yesNo
                "
            >
                <div class="question-title margin-bottom-2">
                    {{ index + 1 }}. {{ interviewQuestionsWithFeedbackResult.question }}
                </div>
                <div class="feedback">
                    <div
                        class="value-stat padding-left-1 padding-top-1 padding-bottom-1"
                        [class.grey]="
                            interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                .interviewersThatSelectedYesPerc > 0
                        "
                    >
                        <div class="value padding-left-1">Yes</div>
                        <div class="stat margin-left-3">
                            {{
                                interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                    .interviewersThatSelectedYesPerc
                            }}%
                        </div>
                    </div>
                    <div class="interviewer-count">
                        <span>{{
                            interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                .interviewersThatSelectedYes
                        }}</span
                        ><mat-icon svgIcon="profile"></mat-icon>
                    </div>
                </div>
                <div class="feedback padding-top-1 padding-bottom-1">
                    <div
                        class="value-stat padding-left-1 padding-top-1 padding-bottom-1"
                        [class.grey]="
                            interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                .interviewersThatSelectedNoPerc > 0
                        "
                    >
                        <div class="value padding-left-1">No</div>
                        <div class="stat margin-left-3">
                            {{
                                interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                    .interviewersThatSelectedNoPerc
                            }}%
                        </div>
                    </div>
                    <div class="interviewer-count">
                        <span>{{
                            interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                .interviewersThatSelectedNo
                        }}</span
                        ><mat-icon svgIcon="profile"></mat-icon>
                    </div>
                </div>
            </ng-container>

            <!-- Open Question-->
            <ng-container
                *ngIf="
                    interviewQuestionsWithFeedbackResult.interviewQuestionType.name ===
                    applicantInterviewQuestionTypes.openQuestion
                "
            >
                <div class="question-title margin-bottom-2">
                    {{ index + 1 }}. {{ interviewQuestionsWithFeedbackResult.question }}
                </div>
                <div
                    *ngFor="
                        let computedStat of interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                            .computedStatForOpenQuestionValues
                    "
                    class="feedback margin-bottom-2"
                >
                    <ng-container *ngIf="computedStat.openQuestionFeedback">
                        <div class="open-question-value">{{ computedStat.openQuestionFeedback }}</div>
                        <div class="interviewer-count">
                            <span>{{ computedStat.feedbackCount }}</span
                            ><mat-icon svgIcon="profile"></mat-icon>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!computedStat.openQuestionFeedback">
                        <div class="open-question-value">
                            {{ 'applicant-tracker.applicant-interview-feedback-results.noFeedback' | translate }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Multiple Choice -->
            <ng-container
                *ngIf="
                    interviewQuestionsWithFeedbackResult.interviewQuestionType.name ===
                    applicantInterviewQuestionTypes.multipleChoice
                "
            >
                <div class="question-title margin-bottom-2">
                    {{ index + 1 }}. {{ interviewQuestionsWithFeedbackResult.question }}
                </div>

                <div
                    *ngFor="
                        let computedStat of interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                            .computedStatForInterviewQuestionValues
                    "
                    class="feedback"
                >
                    <div
                        class="value-stat padding-left-1 padding-top-1 padding-bottom-1"
                        [class.grey]="computedStat.feedbackPerc > 0"
                    >
                        <div class="value padding-left-1">{{ computedStat.multipleChoiceQuestion }}</div>
                        <div class="stat margin-left-3">{{ computedStat.feedbackPerc }}%</div>
                    </div>
                    <div class="interviewer-count">
                        <span>{{ computedStat.feedbackCount }}</span
                        ><mat-icon svgIcon="profile"></mat-icon>
                    </div>
                </div>
            </ng-container>

            <!-- Opinion Scale -->

            <ng-container
                *ngIf="
                    interviewQuestionsWithFeedbackResult.interviewQuestionType.name ===
                    applicantInterviewQuestionTypes.opinionScale
                "
            >
                <div class="question-title margin-bottom-2">
                    {{ index + 1 }}. {{ interviewQuestionsWithFeedbackResult.question }}
                </div>

                <div class="opinion-scale-feedback">
                    <ng-container
                        *ngFor="
                            let computedStat of interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                .computedStatForInterviewQuestionValues;
                            let index = index
                        "
                    >
                        <div>
                            <div class="opinion-scale-value">
                                <ng-container *ngIf="computedStat.feedbackPerc > 0">
                                    <div class="opinion-scale-feedback-percentage padding-top-3">
                                        {{ computedStat.feedbackPerc }}%
                                    </div>
                                    <div class="interviewer-count margin-top-3">
                                        <span>{{ computedStat.feedbackCount }}</span
                                        ><mat-icon svgIcon="profile"></mat-icon>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="opinion-scale-weight">{{ index + 1 }}</div>

                            <div class="opinion-scale-weight">
                                <div
                                    *ngIf="
                                        index === 0 &&
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[0]
                                    "
                                    class="opinion-scale-question-value"
                                >
                                    {{
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[0]
                                    }}
                                </div>
                                <div
                                    *ngIf="
                                        index === 2 &&
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[1]
                                    "
                                    class="opinion-scale-question-value"
                                >
                                    {{
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[1]
                                    }}
                                </div>
                                <div
                                    *ngIf="
                                        index === 4 &&
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[2]
                                    "
                                    class="opinion-scale-question-value"
                                >
                                    {{
                                        interviewQuestionsWithFeedbackResult.applicantInterviewFeedbackResults
                                            .opinionScaleValues[2]
                                    }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #emptyState>
        <app-empty-state
            label="applicant-tracker.applicant-interview-feedback-results.emptyStateLabel"
            src="/assets/illustrations/clipboard-speech-bubble.png"
        >
        </app-empty-state>
    </ng-template>
</ui-card>
